import React from 'react';

const EndActivity = () => {
    return (
        <div className="end-activity-text">
            <p>Thank you for completing this activity!</p>
        </div>
    );
}

export default EndActivity;